export type ElectronAuthCallback = {
  code?: string;
  error?: string;
  errorDescription?: string;
};

export const getElectronAuthRedirectTarget = ({
  code,
  error,
  errorDescription
}: ElectronAuthCallback): string | null => {
  if (code) {
    return `code/${code}`;
  }

  if (error || errorDescription) {
    const searchParams = new URLSearchParams();

    if (error) {
      searchParams.set('error', error);
    }

    if (errorDescription) {
      searchParams.set('error_description', errorDescription);
    }

    return `auth-error?${searchParams.toString()}`;
  }

  return null;
};
